import ResetPasswordPageContent from "@/app/reset-password/page";

export default function ResetPasswordPage() {
  return <ResetPasswordPageContent />;
}
